import Splide from "@splidejs/splide";

const bannerSliders = document.querySelectorAll(".banner-carousel");

bannerSliders.forEach((slider) => {
  // Hero slider config
  const heroSlider = new Splide(
    slider.querySelector(".banner-carousel-hero > .splide"),
    {
      type: "fade",
      pagination: false,
      arrows: false,
    }
  );
  heroSlider.mount();

  // Card slider config
  const cardSlider = new Splide(
    slider.querySelector(".banner-carousel-card > .splide"),
    {
      type: "slide",
      pagination: false,
    }
  );
  cardSlider.sync(heroSlider);
  cardSlider.mount();

  // Create pagination slide number - create an element to store current slide when page loads
  const currentSlideInit = cardSlider.root.querySelector(
    ".banner-carousel-current"
  );
  const indexPlusOneInit = cardSlider.index + 1;
  currentSlideInit.innerHTML = indexPlusOneInit.toString();

  // Create pagination slide length - create a dynamic element to store length of carousel
  const totalSlidesEl = cardSlider.root.querySelector(".banner-carousel-total");
  totalSlidesEl.innerHTML = cardSlider.length.toString();

  // Pagination arrows and children - hide on all devices if there is only one slide,
  // hide on desktop if there are three slides or fewer
  const paginationEl = cardSlider.root.querySelector(".splide__arrows");
  if (cardSlider.length < 2) {
    paginationEl.classList.add("banner-carousel-pagination--hidden");
  }

  // Set initial CTA button text and link
  const activeSlideInit = cardSlider.root.querySelector(".is-active");

  let activeLinkUrl = activeSlideInit.dataset.linkUrl;
  let activeLinkText = "";
  let activeLinkTarget = "";
  let ctaButtonEl = "";

  const ctaButtonContainer = cardSlider.root.querySelector(
    ".desktop-cta-button-container"
  );

  ctaButtonEl =
    ctaButtonContainer.firstElementChild.firstElementChild.firstElementChild;

  if (activeLinkUrl) {
    activeLinkText = activeSlideInit.dataset.linkText;
    activeLinkTarget = activeSlideInit.querySelector("a").target;

    if (!activeLinkUrl || activeLinkText === "") {
      ctaButtonEl.classList.add("cta-btn-hide");
    } else {
      ctaButtonEl.innerHTML = activeLinkText.toString();
      ctaButtonEl.href = activeLinkUrl.toString();
      if (activeLinkTarget === "_blank") {
        ctaButtonEl.target = "_blank";
      }
    }

    /* Event listeners to change current slide each time carousel moves including
    CTA button */

    // Make CTA button disappear when carousel moves
    cardSlider.on("move", () => {
      ctaButtonEl.classList.add("cta-btn-hide");
    });
  } else {
    const ctaPaginationContainer = cardSlider.root.querySelector(
      ".cta-pagination-container"
    );

    if (!(activeLinkUrl || activeLinkText) && cardSlider.length < 2) {
      ctaPaginationContainer.classList.add("hidden");
    }

    cardSlider.root
      .querySelector(".desktop-cta-button-container")
      .firstElementChild.firstElementChild.firstElementChild.classList.add(
        "cta-btn-hide"
      );
  }

  cardSlider.on("moved", () => {
    // Update current slide number once slide has moved
    const currentSlideEl = cardSlider.root.querySelector(
      ".banner-carousel-current"
    );
    const indexPlusOne = cardSlider.index + 1;
    currentSlideEl.innerHTML = indexPlusOne.toString();

    // Update CTA button text and link once slide has moved
    const activeButton = cardSlider.root.querySelector(".is-active");
    if (
      activeButton &&
      activeButton.hasAttribute("data-link-url") &&
      activeButton.getAttribute("data-link-url") !== ""
    ) {
      activeLinkUrl = activeButton.dataset.linkUrl;
      activeLinkText = activeButton.dataset.linkText;
      activeLinkTarget =
        activeButton.querySelector("a").target !== ""
          ? activeButton.querySelector("a").target
          : "";

      if (activeLinkUrl.length > 0) {
        ctaButtonEl.classList.remove("cta-btn-hide");
        ctaButtonEl.innerHTML = activeButton.dataset.linkText.toString();
        ctaButtonEl.href = activeButton.dataset.linkUrl.toString();
        if (activeLinkTarget === "_blank") {
          ctaButtonEl.target = "_blank";
        } else if (ctaButtonEl.hasAttribute("target")) {
          ctaButtonEl.removeAttribute("target");
        }
      }
    } else {
      ctaButtonEl.classList.add("cta-btn-hide");
    }
  });
});
